import { render, staticRenderFns } from "./CategoriesMenu.vue?vue&type=template&id=c350be48&scoped=true&"
import script from "./CategoriesMenu.vue?vue&type=script&lang=js&"
export * from "./CategoriesMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesMenu.vue?vue&type=style&index=0&id=c350be48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c350be48",
  null
  
)

export default component.exports